/*
EnterKey Submit

Submits parent Form when "Enter" key is pressed on target element

### Html Attributes

```
	data-enterkey-submit
```

Markup:
<form id="site-search">...
<select
	class="form-element"
	data-enterkey-submit
	>
	Submit form
</select>
</form>

*/
import $ from 'jquery';

/* global $:true */
import debug from 'debug';
import plugin from '@core/plugins/lib';
import { ELEMENT_SELECTOR, PLUGIN_NAME } from './index';

const MODULE_NAME = 'plugins/enterkey-submit';
const log = debug(MODULE_NAME);

log('registerd');

class EnterkeySubmit {
	constructor(element, options) {
		log('element', element);
		log('options', options);
		this.element = element;
		this.options = options;
		this.$element = $(element);

		this.targetForm = this.$element.closest("form")[0];

		log('ready', this.$element);
		log('targetForm', this.targetForm);
		this.watch();
	}

	watch() {
		var targetForm=this.targetForm;
		this.$element.on('keypress',function(e){
			log('key',e.key);
			log('event',e);
			if(e.key == "Enter")// the enter key code
				{
					log('targetForm',targetForm);
					e.preventDefault(); // Ensure it is only this code that rusn
					targetForm.requestSubmit();
				}

		});
	}
}

EnterkeySubmit.DEFAULTS = {
};

export default EnterkeySubmit;
//plugin(PLUGIN_NAME, EnterkeySubmit);



// WEBPACK FOOTER //
// ./project/client/src/core/plugins/jquery__enterkey-submit/plugin.js